import { FEATURES, isFeatureEnabled } from '~src/features';
import { isLoggedUserSuperUser } from '~src/user';

export default async function canCreateBackgroundWithAi() {
  const [featureResult, superUserResult] = await Promise.allSettled([
    isFeatureEnabled(FEATURES.AI_USE_AI_BG, false),
    isLoggedUserSuperUser(),
  ]);

  const isFeatureAllowed =
    featureResult.status === 'fulfilled' && featureResult.value === true;
  const isSuperUser =
    superUserResult.status === 'fulfilled' && superUserResult.value === true;

  return isFeatureAllowed || isSuperUser;
}
